export default {
    install: (app, options) => {
        app.config.globalProperties.$fromIndexToMonth = $fromIndexToMonth;   
        app.config.globalProperties.$toYYYYMMMDDDHHmmss = $toYYYYMMMDDDHHmmss;             
        app.config.globalProperties.$convertToDate = $convertToDate;   
        app.provide('DateTimeUtil', options);
    }
}


export function $toYYYYMMMDDDHHmmss(dt) {
  if(dt){
     
    return dt.getFullYear()+"-"+this.$fromIndexToMonth(dt.getMonth())
        +"-"+formatTimeIntString(dt.getDate())+" "
        +formatTimeIntString(dt.getHours())+":"+formatTimeIntString(dt.getMinutes())+":"+formatTimeIntString(dt.getSeconds());
  }
  return null;
}

function formatTimeIntString(t){
    return t<10?("0"+t):(""+t);
}

export function $convertToDate(dtString) {  
    
  if (dtString) {
    var months=["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];  
    var str=dtString.toUpperCase();
    for(var i=0;i<months.length;i++){
        var month=months[i];
        var j=i+1;
        var newStr=str.replace(month,j<10?("0"+j):(""+j));
        if(newStr!==str){
            return new Date(newStr.replace(" ","T")+"Z");
        }
    }
  } 
  return null;
}

export function $fromIndexToMonth(monthIdx){
    
        var idx=parseInt(monthIdx+"");    
        var months=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return months[idx];
    
    
}